import { ROUTE_PATHS } from "../../../utilities/constants"
import { readTypeFilter } from "../../../data-utils/exerciseType"

// Filters the dashboard hands to the Exercises list through the URL: a scenario (served by the
// exercises API's own `test` filter) and how the exercise is run (the row's setupType, which the
// server classifies exactly as the dashboard's "How exercises are run" card).
export const SETUP_FILTER_LABELS = Object.freeze({
  collaborative: "Collaborative",
  facilitated: "Facilitated",
  independentGroup: "Independent group",
  solo: "Solo",
})

const MAX_SCENARIO_ID = 200

export const readExerciseLinkFilters = (search) => {
  const params = new URLSearchParams(search ?? "")
  const scenario = (params.get("scenario") ?? "").trim()
  const setup = params.get("setup") ?? ""
  return {
    scenario: scenario && scenario.length <= MAX_SCENARIO_ID ? scenario : null,
    setup: Object.prototype.hasOwnProperty.call(SETUP_FILTER_LABELS, setup) ? setup : null,
    // CTF reports spec §6: Type = CTF | Training | Assessment (absent = All), shareable in the URL.
    type: readTypeFilter(search),
  }
}

export const exercisesLinkFor = ({ scenario = null, setup = null, type = null } = {}) => {
  const params = new URLSearchParams()
  if (scenario) params.set("scenario", scenario)
  if (setup) params.set("setup", setup)
  if (type) params.set("type", type)
  const qs = params.toString()
  return qs ? `${ROUTE_PATHS.GAME_ROOT}?${qs}` : ROUTE_PATHS.GAME_ROOT
}

export const searchWithout = (search, key) => {
  const params = new URLSearchParams(search ?? "")
  params.delete(key)
  const qs = params.toString()
  return qs ? `?${qs}` : ""
}

// Group members sit under their group, so only top-level rows are matched.
export const matchesSetupFilter = ({ row, setup }) => !setup || row?.setupType === setup

/** The same search string with `?type=` set to `type` (or removed for All), other params kept. */
export const searchWithType = (search, type) => {
  const params = new URLSearchParams(search ?? "")
  if (type) params.set("type", type)
  else params.delete("type")
  const qs = params.toString()
  return qs ? `?${qs}` : ""
}
